export default "__VITE_ASSET__6785a205__"